const emojipedia = [
  {
    id: 1,
    emoji: "💪",
    name: "Tense Biceps",
    meaning:
      "“You can do that!” or “I feel strong!” Arm with tense biceps. Also used in connection with doing sports, e.g. at the gym."
  },
  {
    id: 2,
    emoji: "🙏",
    name: "Person With Folded Hands",
    meaning:
      "Two hands pressed together. Is currently very introverted, saying a prayer, or hoping for enlightenment. Is also used as a “high five” or to say thank you."
  },
  {
    id: 3,
    emoji: "🤣",
    name: "Smiling Face With Open Mouth & Cold Sweat",
    meaning:
      "This is funny! A smiley face, rolling on the floor, laughing. The face is laughing boundlessly. The emoji version of “rofl“. Stands for „rolling on the floor, laughing“."
  },
  {
    id: 4,
    emoji: "😅",
    name: "Rolling On The Floor, Laughing",
    meaning:
      "Sweaty smile. Relief that a tight situation went well or was coped with positively, e.g. an important appointment. A difficult event is imminent and you are already nervous."
  },
  {
    id: 5,
    emoji: "😎",
    name: " Face With Sunglasses",
    meaning:
      "I'm the king of the world! Mr. Cool Smiley with sunglasses. Is totally self-assured and relaxed. Everything is absolutely easy and cool. Also a symbol for sun, summer holidays, and holidays on the beach."
  },

  {
    id: 6,
    emoji: "🤨",
    name: "Face With a Raised Eyebrow",
    meaning:
      "With the questioning look on the face, resembles the actor “The Rock“ (Dwayne Johnson). Can be used to express skepticism, disbelief or disapproval."
  },
  {
    id: 7,
    emoji: "😏",
    name: "Smirking/Whimsical Face",
    meaning:
      "Half a smile that oozes with complacency. Represents irony, coolness or playfulness. Be careful: Somebody could be up to something. Used as an offensive look for flirting or sexual innuendo."
  },
  {
    id: 8,
    emoji: "🤦‍♂️",
    name: "Man Grabbing His Head",
    meaning:
      "Facepalm describes a gesture that became popular through the Star Trek series. “That cannot be true!“ is what you think when facing the stupidity of other people. Can also be used if you are embarrassed for someone else."
  },
  {
    id: 9,
    emoji: "😁",
    name: "Grinning Face With Smiling Eyes",
    meaning:
      "Happy face with a mischievous laugh. Represents lightheartedness and exuberance. Full of joy due to an event, excited and agitated or just a bit embarrassed."
  },
  {
    id: 10,
    emoji: "😉",
    name: "Winking Face",
    meaning:
      "Smiley blinks mischievously with one eye. Expression of humor, has been pulling a practical joke, is flirting with you or has an ulterior motive. The wink weakens the message: do not take it seriously, regard it as humorous."
  },
  {
    id: 11,
    emoji: "🥺",
    name: "Face with begging eyes",
    meaning:
      "The big eyes are shining, devoted facial expression. The emoji is entreatingly begging for something: wants to borrow some money or the car. If you cannot get ahead by asking for something, puppy dog eyes are the last resort to get what you want."
  },
  {
    id: 12,
    emoji: "😭",
    name: "Loudly Crying Face",
    meaning:
      "Emoji is both very sad and distraught, or is dying of laughter. Tears are pouring out of the eyes like a waterfall. Represents injury, pain or defeat. Is also used ironically or something is so funny that you die of laughter."
  },
  {
    id: 13,
    emoji: "😱",
    name: "Face Screaming in Fear",
    meaning:
      "Horror-stricken face with two hands, screaming. Is scared stiff, feeling nothing but fear and panic. The creepy emoji can also be used ironically or as a symbol for Halloween."
  },
  {
    id: 14,
    emoji: "🤔",
    name: "Thinking Face",
    meaning:
      "The thinker's pose: Thoughtful face with the characteristic hand on the chin. Puts a statement, a person's intelligence, or an idea into question. Is mulling over something or thinking about a brilliant idea."
  },
  {
    id: 15,
    emoji: "😬",
    name: "Grimacing Face",
    meaning:
      "This is really embarrassing for me now! Expression of nervousness, awkwardness or embarrassment. Scared and guilty smile: Someone has done something stupid and tries to resolve the tense situation by grimacing."
  },

];

export default emojipedia;